import { CURRENCY_SYMBOLS, CurrencyType } from "@rshbintech.dboul/core-ui";
import { getPluralEnding } from "@rshbintech.dboul/utils";
import { DocumentsInfo, SigningTypes } from "../../types";
import {
  CURRENCY_AMOUNT_INFO,
  DOCUMENT_PLURAL_FORMS,
  SIGNING_PLURAL_FORMS,
  SIGNING_STATUSES,
} from "../../constants";
import {
  SIGNING_DOCUMENTS_ANNOTATION_DICTIONARY,
  SIGNING_DOCUMENTS_ANNOTATION_PLACEHOLDERS,
} from "../constants";

export const getStatusAnnotationWithData = (
  status: string,
  signingType: SigningTypes,
  documentsTotalCount: number,
  documentsInfo: DocumentsInfo,
  signedDocumentsCount: number,
  validDocumentsTotalCount: number
) => {
  const isAllDocumentsValid = documentsTotalCount === validDocumentsTotalCount;

  const signedDocumentsCountPlural = getPluralEnding(
    signedDocumentsCount,
    DOCUMENT_PLURAL_FORMS
  );

  const validDocumentsCountPlural = getPluralEnding(
    validDocumentsTotalCount,
    DOCUMENT_PLURAL_FORMS
  );

  const signingPlural = getPluralEnding(
    signedDocumentsCount,
    SIGNING_PLURAL_FORMS[signingType]
  );

  const signingFirstWord =
    status === SIGNING_STATUSES.SIGNING_COMPLETED
      ? SIGNING_DOCUMENTS_ANNOTATION_DICTIONARY.FIRST_WORD
      : signingPlural;

  const documentsSum =
    status === SIGNING_STATUSES.READY_TO_BE_SIGNED
      ? documentsInfo.validDocuments
      : documentsInfo.signedDocuments;

  const textBegin =
    status === SIGNING_STATUSES.READY_TO_BE_SIGNED
      ? `${SIGNING_DOCUMENTS_ANNOTATION_DICTIONARY.FIRST_WORD} ${validDocumentsTotalCount} ${validDocumentsCountPlural}`
      : `${signingFirstWord} ${signedDocumentsCount} ${signedDocumentsCountPlural}`;

  const textMiddle = isAllDocumentsValid
    ? ""
    : SIGNING_DOCUMENTS_ANNOTATION_DICTIONARY.DOCUMENTS_TOTAL.replace(
        SIGNING_DOCUMENTS_ANNOTATION_PLACEHOLDERS.DOCUMENTS_TOTAL_COUNT,
        String(documentsTotalCount)
      );

  const documentSumInformation = Object.entries(documentsSum)
    .map(
      ([currency, { sum, count }]) =>
        `${count} ${CURRENCY_AMOUNT_INFO} ${sum} ${
          CURRENCY_SYMBOLS[currency as CurrencyType]
        }`
    )
    .join("\n");

  const customText = `${textBegin}${textMiddle}: \n ${documentSumInformation}`;

  return customText;
};
